import React from 'react';
import { ConfigProvider, Layout, Flex } from 'antd';
import BoschStrip from '../../../assets/cd_bosch_supergraphic.png';
import BoschLogoBlackSvg from '../../../assets/bosch-logo-black.svg';
import RideBuddyLogoTextSvg from '../../../assets/ridebuddy-logo-text-blue.svg';
import PropTypes from 'prop-types';

const PageLayout = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerPadding: '9px 22px 9px 22px',
            headerHeight: '3rem',
          },
        },
      }}
    >
      <Layout>
        <Flex vertical>
          <img alt="graphic" src={BoschStrip} className="bosch-strip" />
          <Flex className="full-height" vertical>
            <Flex
              gap={24}
              className="full-width"
              wrap="wrap"
              align="center"
              style={{ padding: '15px 22px 9px 22px' }}
            >
              <div className="logo-ridebuddy">
                <Flex gap={8} style={{ cursor: 'pointer' }}>
                  <img src={RideBuddyLogoTextSvg} alt="RideBuddy logo" />
                </Flex>
              </div>
              <img
                src={BoschLogoBlackSvg}
                alt="Bosch logo"
                className="logo-bosch"
              />
            </Flex>
            <div className="container-register">{children}</div>
          </Flex>
        </Flex>
      </Layout>
    </ConfigProvider>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node,
};

export default React.memo(PageLayout);
